import { Component, OnInit,ElementRef, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-student-edit',
  templateUrl: './student-edit.component.html',
  styleUrls: ['./student-edit.component.scss',
  '../../../../../../assets/sass/pages/page-users.scss',
  '../../../../../../assets/sass/libs/select.scss'],
  encapsulation: ViewEncapsulation.None
  
})

export class StudentEditComponent implements OnInit {
  @ViewChild('fileInput') myInputVariable: ElementRef;
  selectedValue:string[]=[];
  isAdmin:boolean=false;
  userId:any;
  userData={
    name:'',
    email	:'', 
    college	:'',
    phoneNumber	:'',
    role	:{_id:''},
    lastQualification:'', 
    course	:[{_id:''}],
    batch:[{_id:''}],
    password:'',	
    image:''
  };
  roles:[]
  courses=[]
  fileData:File;
  formData=new FormData
  imgUrl:any;
  batchList=[];
  selectedBatch:string[]=[]
  imageUrl=environment.apiUrls.imageUrl;

  constructor(private apiService:ApiService,
    public toastr: ToastrService,
    private route:Router,
    private activatedroute:ActivatedRoute) {
      this.activatedroute.paramMap.subscribe(params => { 
        this.userId = params.get('id'); 
        console.log('userId',this.userId)
        });
     }

ngOnInit() {
this.getCourseList();
this.getUserById();
this.getBatchList()
}


getUserById(){
  this.apiService.getUserbyId(this.userId).subscribe((res:any)=>{
  this.userData=res.data
  console.log('user Data',this.userData)
  //  this.selectedValue = this.userData.course[0]._id
  for(let item of this.userData.course){
     this.selectedValue.push(item._id)
  }
  this.selectedValue = this.selectedValue.map((item)=>item)
  for(let item of this.userData.batch){
    this.selectedBatch.push(item._id)
 }
 this.selectedBatch = this.selectedBatch.map((item)=>item)
  })
}

getCourseList(){
  this.apiService.getCourseList(1,100).subscribe((res:any)=>{
    console.log(res)
    this.courses=res.data.items
  })
 }
 getCourseId(event:any){
  // this.selectedValue=event.target.value
  console.log('selected course',this.selectedValue)
 }
 getBatchList(){
  this.apiService.getBatchList(1,100).subscribe((res:any)=>{
    console.log(res)
    this.batchList=res.data.items 
  })
 }
 getBatchId(event:any){
  console.log('batch',this.selectedBatch)
 }
userUpdate(){
  
  if(this.userId){
    for (let item of this.selectedValue){
      console.log(item)
      this.formData.append('course[]', item)
    }
    for (let item of this.selectedBatch){
      console.log(item)
      this.formData.append('batch[]', item)
    }
    this.formData.append('name',this.userData.name),
    this.formData.append('email',this.userData.email),
    this.formData.append('college',this.userData.college),
    this.formData.append('phoneNumber',this.userData.phoneNumber),
    this.formData.append('role',this.userData.role._id),
    this.formData.append('lastQualification',this.userData.lastQualification),
    this.formData.append('password',this.userData.password),
    this.formData.append('image',this.fileData),
    this.apiService.updateUser(this.userId,this.formData).subscribe((res:any)=>{
      if(res.statusCode === 200){
        console.log('update res',res)
        this.toastr.success('student update seccessfully',res.message) 
     
      this.route.navigate(['/profile/student-dash'])
   }  else{this.toastr.error(res.error)}
  })
  
  }
  else{
    alert('Something went Wrong!!!')
  }  
}
onSelectFile(event:any){
  if (event.target.files && event.target.files[0]) {
    var reader = new FileReader();
    this.fileData = event.target.files[0];
    reader.readAsDataURL(event.target.files[0]);
    reader.onload=(event)=>{
      this.imgUrl=reader.result
    }
    console.log('event',this.fileData)
  }
}


resetImage(){
  this.imgUrl=''
  this.myInputVariable.nativeElement.value=null
  this.fileData=this.myInputVariable.nativeElement.files
  console.log( '===',this.myInputVariable.nativeElement.files);
}
back(){
  this.route.navigate(['/profile/student-dash'])    

}
}
